module.exports = __webpack_public_path__ + "img/1.109a7a31.png";